/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Column, Bleed } from '../../../../../styles/Grid';
import Picture from '../../../../ui/Picture';
import { Breakpoints } from '../../../../../styles/Grid/GridSizes';
import { pictureStyles, imageStyles } from '../../index.styles';
import { CLOUDINARY_BASE_VALUES } from '../../../../../utils/constants';
import {
  containerCss,
  containerImageLeftCss,
  containerImageRightCss,
  imageLeftCss,
  imageRightCss,
} from './index.styles';

const imageLeftSizes = {
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '1:1',
    gravity: 'auto:subject',
    height: 776,
    width: 776,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '1:1',
    gravity: 'auto:subject',
    height: 776,
    width: 776,
  },
  [Breakpoints.md]: {
    hidden: true,
  },
  [Breakpoints.sm]: {
    hidden: true,
  },
};

const imageRightSizes = {
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '1:1',
    gravity: 'auto:subject',
    height: 404,
    width: 404,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '1:1',
    gravity: 'auto:subject',
    height: 404,
    width: 404,
  },
  [Breakpoints.md]: {
    hidden: true,
  },
  [Breakpoints.sm]: {
    hidden: true,
  },
};

const FourthLgTabImage = (imageRight, imageLeft) => {
  return (
    <div css={containerCss}>
      <Column cols={{ lg: 1 }}>
        <Bleed left>
          <div css={containerImageLeftCss}>
            <Picture
              image={imageLeft}
              imageSizes={imageLeftSizes}
              pictureCss={pictureStyles}
              imageCss={[imageStyles, imageLeftCss]}
            />
          </div>
        </Bleed>
      </Column>
      <Column cols={{ lg: 3 }} offsets={{ lg: 9 }}>
        <Bleed right>
          <div css={containerImageRightCss}>
            <Picture
              image={imageRight}
              imageSizes={imageRightSizes}
              pictureCss={pictureStyles}
              imageCss={[imageStyles, imageRightCss]}
            />
          </div>
        </Bleed>
      </Column>
    </div>
  );
};

export default FourthLgTabImage;
